import * as React from 'react'
import { PanelBase, PanelBody, PanelHeader, PanelFooter } from './PanelBase'
import { Props } from './panel-types'

type PanelProps = Props & {
    footer?: React.ReactNode
    title?: string
}

/**
 * Full panel to avoid import all separated parts.
 * @param children
 * @param footer
 * @param title
 * @param _props
 * @constructor
 */
const Panel: React.FC<PanelProps> = ({ children, footer, title, ..._props }) => {
    return (
        <PanelBase {..._props}>
            <PanelHeader>{title}</PanelHeader>
            <PanelBody>{children}</PanelBody>
            {footer && <PanelFooter>{footer}</PanelFooter>}
        </PanelBase>
    )
}

export default React.memo(Panel)
